export default __webpack_public_path__ + "static/morotti-4c04006a7ccec96129a037f0ebad5cc6.jpeg";